<template>
  <v-row>
    <v-col
      cols="12"
      class="mb-2"
    >
      <v-tabs>
        <v-tab exact :to="{name: 'system-admin-settings'}">General</v-tab>
        <!--<v-tab exact :to="{name: 'admin-settings-stripe'}">Stripe</v-tab>-->
      </v-tabs>

      <v-card class="white">
        <v-card-text>
          <v-tabs-items v-model="currentTab">
            <v-tab-item
              value="general"
              transition="none"
              reverse-transition="none"
            >
              <admin-general />
            </v-tab-item>

            <!--<v-tab-item
              value="stripe"
              transition="none"
              reverse-transition="none"
            >
              <admin-stripe />
            </v-tab-item>-->
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import AdminGeneral from '@/views/admin/settings/General'
//import AdminStripe from '@/views/admin/settings/Stripe'

export default {
  name: 'AdminSettingsIndex',
  components: {
    AdminGeneral,
    //AdminStripe
  },
  data: () => ({
    currentTab: 'general'
  }),
  watch: {
    $route (newVal) {
      if(newVal.name == 'admin-settings') this.currentTab = 'general'
      if(newVal.name == 'admin-settings-stripe') this.currentTab = 'stripe'
    }
  }
}
</script>